<iframe class="pdf-viewer" [src]="safeUrl"></iframe>
